module.exports = __webpack_public_path__ + "static/media/ic_password_danger.22f6e39a.svg";